import { bridgeCallFunc, getTrans } from './instantLoaded/tools';
import { addTip } from './sessionUtils';
import userStore from '@/stores/user';

export default (successCb, failureCb) => {
  try {
    bridgeCallFunc(() => {
      if (!userStore.ifShowLoginOverfast) {
        window.bridgeCallHandler('login', {
          // for Android, force app don't show the popup
          hidePopup: 1,
          // let login page focus on the 'login' tab'
          redirectTab: 1,
          // Android: after login success will back to Home, this tells app redirect to our target url
          redirectPath: `main?apprl=${encodeURIComponent(window.location.href)}`,
        }, (res) => {
          if (res.status === 1) {
            successCb && successCb(res);
          } else {
            failureCb && failureCb(res);
          }
        });
        userStore.UPDATE_SHOWLOGIN_TIMESTAMP();
      }
    });
  } catch (err) {
    addTip(getTrans('error_bad_network'));
  }
};
